<template>
  <el-dialog
    v-model="visible"
    title="Подключение Email"
    width="500px"
    destroy-on-close
  >
    <el-form ref="formRef" :model="form" label-width="130px">
      <el-form-item
        label="Email"
        prop="email_login"
        :rules="[
          { required: true, message: 'Введите Email', trigger: 'blur' },
          { type: 'email', message: 'Некорректный Email', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.email_login" placeholder="user@example.com" />
      </el-form-item>

      <el-form-item
        label="Пароль"
        prop="email_password"
        :rules="[
          { required: true, message: 'Введите пароль', trigger: 'blur' }
        ]"
      >
        <el-input v-model="form.email_password" show-password />
      </el-form-item>

      <el-form-item
        label="IMAP Host"
        prop="imap_host"
        :rules="[
          { required: true, message: 'Укажите IMAP сервер', trigger: 'blur' }
        ]"
      >
        <el-input v-model="form.imap_host" placeholder="imap.example.com" />
      </el-form-item>

      <el-form-item
        label="SMTP Host"
        prop="smtp_host"
        :rules="[
          { required: true, message: 'Укажите SMTP сервер', trigger: 'blur' }
        ]"
      >
        <el-input v-model="form.smtp_host" placeholder="smtp.example.com" />
      </el-form-item>

      <el-form-item label="SSL/TLS">
        <el-switch v-model="form.ssl" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="close">Отмена</el-button>
      <el-button
        :loading="testing"
        :type="testPassed ? 'success' : 'primary'"
        @click="handleButtonClick"
      >
        {{ testing ? 'Проверка...' : (testPassed ? 'Сохранить' : 'Проверить подключение') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'EmailSettingsDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'saved'],
  computed: {
    ...mapState('messengers', ['messengers']),
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },
  data() {
    return {
      form: {
        email_login: '',
        email_password: '',
        imap_host: '',
        smtp_host: '',
        ssl: true
      },
      testing: false,
      testPassed: false
    }
  },
  methods: {
    ...mapActions('messengers', ['fetchMessengers', 'testEmailConnection', 'addMessenger']),
    async testConnection() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.testing = true
        this.testPassed = false
        try {
          const res = await this.testEmailConnection(this.form)
          if (res?.success) {
            ElMessage.success('Подключение успешно проверено')
            this.testPassed = true
            await this.fetchMessengers()
          } else {
            ElMessage.error(res?.message || 'Ошибка подключения')
          }
        } catch (e) {
          ElMessage.error('Не удалось подключиться к серверу')
        } finally {
          this.testing = false
        }
      })
    },
    async saveEmailSettings() {
      await this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          const res = await this.$store.dispatch('messengers/addMessenger', { ...this.form, type: 'email' })
          if (res?.list) {
            ElMessage.success('Email успешно добавлен')
            this.$emit('saved')
            this.close()
          } else {
            ElMessage.error(res?.message || 'Ошибка при сохранении')
          }
        } catch (e) {
          ElMessage.error('Ошибка при сохранении')
        }
      })
    },
    async handleButtonClick() {
      if (this.testing) return
      if (this.testPassed) {
        await this.saveEmailSettings()
      } else {
        await this.testConnection()
      }
    },
    close() {
      this.visible = false
      this.testPassed = false
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 10px;
}
</style>
